export const Know_More_Mentor = {
  title:
    "Mentors play a vital role in shaping future AI practitioners. By sharing your expertise, you help learners navigate real-world problems, build systems that mirror industry workflows, and develop the confidence to move from theory to execution. Your guidance creates impact not just on projects, but on careers.",

  value_points: [
    {
      label: "Work on real problems",
      desc: "Actual industry and research-grade problem statements.",
    },
    {
      label: "Cross-demographic cohorts",
      desc: "You'll guide both students and working professionals enrolled in the same cohort.",
    },
    {
      label: "Research-aware environment",
      desc: "Learners read papers and replicate work - your mentorship bridges theory and deployment.",
    },
    {
      label: "Visible impact",
      desc: "Cohort learners have gone to events like GHCI, IISc workshops, and industry internships.",
    },
  ],

  how_does_it_work: [
    {
      inner_title: "Explore Programs",
      inner_desc:
        "Discover active and upcoming programs that match your area of expertise - ML, GenAI, deep learning, and AI agents. Each cohort is built around a real industry or research-grade problem statement.",
      img: "/Images/explore_cohorts.png",
      img_alt: "Mentor exploring active AI and machine learning cohorts to guide on v18hub",
    },
    {
      inner_title: "Select Your Role",
      inner_desc:
        "Choose where you'd like to contribute. You can guide learners through the full cohort, workshops, bootcamps, participate in structured milestone reviews, or anchor specific technical sessions, based on your availability and depth of involvement.",
      img: "/Images/mentor_select_your_role.jpg",
      img_alt: "Mentor selecting their preferred mentoring role and involvement level on v18hub",
    },
    {
      inner_title: "Join as a Mentor",
      inner_desc:
        "Register and set your mentoring preferences. You'll be part of a programs ecosystem that includes peers, educators, and industry partners - creating a learning environment that mirrors how real AI teams operate.",
      img: "/Images/mentoring.jpg",
      img_alt: "Industry professional joining as a mentor on v18hub to guide AI learners",
    },
    {
      inner_title: "Track, Guide & See Results",
      inner_desc:
        "Keep track of learner progress, review GitHub documentation, and provide guidance through structured milestones. Past cohort learners guided by mentors have gone on to represent their work at the GHCI-2025, IISc workshops and industry internships.",
      img: "/Images/mentor_guide.png",
      img_alt: "Mentor tracking learner progress and reviewing programs milestones on v18hub",
    },
  ],

  cta: [
    {
      button1: { label: "Explore Programs", href: "/programs" },
      // button2: { label: "Join as a Mentor", href: "/registration/mentor" },
    },
  ],
};
